import Select from 'components/UI/Inputs/select/Select';
import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import CircularLoader from 'components/UI/Loaders/CircularLoader';
import { axiosAiq } from 'config';

import styles from './LocationsDropdown.module.css';

function LocationsDropdown({
    onGetCameras,
    onSelectedLocation,
    onSelectedGate,
    onStreamPerPageChange,
    fetchingStreamsInProgress,
    fetchingStreamsError,
    locationsUrl,
    liveStreamsPerPage,
    streamsPerPageLookup,
    hasFilterByMonitoringObject = false,
}) {
    const defaultGateValue = { id: 0, name: 'All' };
    const [locations, setLocations] = useState({
        selectedLocation: '',
        locationsArr: [],
        gatesArr: [],
        selectedGates: '',
        fetchingInProgress: false,
        locationError: '',
    });
    const { selectedLocation, selectedGates, locationsArr = [], gatesArr = [], fetchingInProgress, locationError } = locations;
    const [streamsPerPage, setStreamsPerPage] = useState({
        streamsPerPageValue: liveStreamsPerPage,
    });
    const [showFilterByMonitoringObject, setShowFilterByMonitoringObject] = useState(false);
    const { streamsPerPageValue } = streamsPerPage;
    const locationLookup = {
        displayExpr: 'name',
        dataSource: locationsArr,
    };
    const gatesLookup = {
        displayExpr: 'name',
        valueExpr: 'id',
        dataSource: gatesArr,
    };

    const fetchLocations = async (url) => {
        try {
            setLocationsPropertyValue('fetchingInProgress', true);
            const response = await axiosAiq(url);
            const { data } = response;
            const locationsArr = data.map((location) => {
                return { name: location.fullName, id: location.id, gates: location.gates };
            });
            setLocationsPropertyValue('locationsArr', locationsArr);
        } catch {
            setLocationsPropertyValue('locationError', 'Error fetching locations');
        }
        setLocationsPropertyValue('fetchingInProgress', false);
    };

    const setLocationsPropertyValue = (property, value) => {
        setLocations((state) => {
            return { ...state, [property]: value };
        });
    };

    const setStreamsPerPagePropertyValue = (property, value) => {
        setStreamsPerPage((state) => {
            return { ...state, [property]: value };
        });
    };

    const locationChangeHandler = (_, selectedLocation) => {
        setShowFilterByMonitoringObject(false);
        setLocationsPropertyValue('selectedGates', '');
        setLocationsPropertyValue('selectedLocation', selectedLocation);
        setLocationsPropertyValue('locationError', '');
        onSelectedLocation(selectedLocation);
        if (hasFilterByMonitoringObject) {
            onSelectedGate(null);
            const gates = locationsArr.find((location) => location.id === selectedLocation.id)?.gates;
            const gatesArr = gates.map((gate) => {
                return { id: gate.id, name: `${gate.name} ${gate.direction}` };
            });
            if (gatesArr.length > 0) {
                setShowFilterByMonitoringObject(true);
            }
            const tempGatesArr = gatesArr.length > 0 ? [defaultGateValue, ...gatesArr] : [];
            setLocationsPropertyValue('gatesArr', tempGatesArr);
        }
    };

    const gatesChangeHandler = (_, selectedGates) => {
        setLocationsPropertyValue('selectedGates', selectedGates);
        setLocationsPropertyValue('locationError', '');
        onSelectedGate(selectedGates);
    };

    const streamsPerPageChangeHandler = (_, streamPerPage) => {
        setStreamsPerPagePropertyValue('streamsPerPage', streamPerPage);
        onStreamPerPageChange(streamPerPage);
    };

    useEffect(() => {
        fetchLocations(locationsUrl);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setLocationsPropertyValue('locationError', fetchingStreamsError);
    }, [fetchingStreamsError]);

    return (
        <div className={styles.location}>
            <Select
                label="Location"
                lookup={locationLookup}
                changeHandler={locationChangeHandler}
                value={selectedLocation}
                isOptionsLoadingInProgress={fetchingInProgress}
                required
                error={locationError}
                touched
                containerClasses={styles['location-autocomplete']}
                helperText={`${typeof locationError === 'string' ? locationError : ''}`}
            />

            {showFilterByMonitoringObject && (
                <Select
                    label="Monitoring Object"
                    lookup={gatesLookup}
                    changeHandler={gatesChangeHandler}
                    value={selectedGates || defaultGateValue}
                    touched
                    containerClasses={styles['location-autocomplete']}
                />
            )}

            {!!streamsPerPageLookup && (
                <Select
                    label="Streams per page"
                    lookup={streamsPerPageLookup}
                    changeHandler={streamsPerPageChangeHandler}
                    value={streamsPerPageValue}
                    required
                    touched
                    containerClasses={styles['location-autocomplete']}
                />
            )}
            <div style={{ position: 'relative', paddingTop: '0.1rem' }}>
                {!!fetchingStreamsInProgress && <CircularLoader containerStyles={{ transform: 'scale(0.8)' }} />}

                <Button
                    sx={{ width: '10rem', visibility: fetchingStreamsInProgress ? 'hidden' : 'visible' }}
                    variant="outlined"
                    onClick={onGetCameras}
                >
                    Get cameras
                </Button>
            </div>
        </div>
    );
}
export default LocationsDropdown;
